// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_li-0";